import _get from 'lodash/get';

import {
  AI_GENERATION_TYPE,
  APPROVAL_RESPONSE_TYPE,
  MANUAL_RESPONSE_TYPE,
} from 'components/modules/business-profile/components/ResponseSettingsForm/ResponseSettingsForm.constants';

import { getLocationDisplay } from '../../../location/services/display';
import {
  REVIEW_RESPONSE_STATUS_FAILED,
  REVIEW_RESPONSE_STATUS_PENDING,
  REVIEW_RESPONSE_STATUS_SUBMITTED,
  REVIEW_RESPONSE_STATUS_CREATED,
  getReviewResponseStatusText,
} from '../../constants';

export function getReviewResponseMetadata(review) {
  return _get(review, 'reviewResponse.metadata') || {};
}

export function getPublishAt(review) {
  return _get(review, 'reviewResponse.publishAt') || null;
}

export function getActionLabelForReview(review) {
  const { generator, type } = getReviewResponseMetadata(review);
  const reviewResponse = _get(review, 'reviewResponse') || {};
  const { status } = reviewResponse;

  let label = 'Edit';
  let icon = 'pencil';

  const isAi = generator === AI_GENERATION_TYPE;
  const isApproval = type === APPROVAL_RESPONSE_TYPE;
  const isManual = type === MANUAL_RESPONSE_TYPE;

  if (status === REVIEW_RESPONSE_STATUS_CREATED) {
    label = 'Reply';
    icon = 'reply';
    return { label, icon };
  }

  if (isAi) {
    if (isApproval) {
      label = 'Approve';
      icon = 'checkmark';
    }
  }

  if (isManual) {
    label = 'Respond';
    icon = 'reply';
  }

  return { label, icon };
}

export function getStatusLabelProps(status) {
  const statusMap = {
    [REVIEW_RESPONSE_STATUS_SUBMITTED]: {
      icon: 'check circle',
      color: 'green',
      label: getReviewResponseStatusText(REVIEW_RESPONSE_STATUS_SUBMITTED),
    },
    [REVIEW_RESPONSE_STATUS_PENDING]: {
      icon: 'clock outline',
      color: 'yellow',
      label: getReviewResponseStatusText(REVIEW_RESPONSE_STATUS_PENDING),
    },
    [REVIEW_RESPONSE_STATUS_FAILED]: {
      icon: 'exclamation circle',
      color: 'red',
      label: getReviewResponseStatusText(REVIEW_RESPONSE_STATUS_FAILED),
    },
    [REVIEW_RESPONSE_STATUS_CREATED]: {
      icon: 'clock outline',
      color: 'green',
      label: getReviewResponseStatusText(REVIEW_RESPONSE_STATUS_CREATED),
    },
  };

  return statusMap[status] || null;
}

export function getLocationName(locationId, locations) {
  if (!locationId) {
    return 'Unknown Location';
  }

  const location = locations.find((loc) => loc.id === locationId);
  if (!location) {
    return `Location ${locationId}`;
  }

  return getLocationDisplay(location);
}
